const directories = [
	{
		path: 'local_governments',
		name: 'Органы местного самоуправления',
		fields: [{ "name": "ID", "key": "id" }, { "name": "Индекс", "key": "order" }, { "name": "Название", "key": "name" }]
	},

	{
		path: 'zones',
		name: 'Зоны ответственности органов власти ПК',
		fields: [{ "name": "ID", "key": "id" }, { "name": "Индекс", "key": "order" }, { "name": "Название", "key": "name" }, { "name": "Организация", "key": "organization" }, { "name": "Должностное лицо", "key": "official" }]
	},

	{
		path: 'types',
		name: 'Вид обращения',
		fields: [{ "name": "ID", "key": "id" }, { "name": "ID МСЭД", "key": "msed_id" }, { "name": "Индекс", "key": "order" }, { "name": "Название", "key": "name" }]
	},

	{
		path: 'socials',
		name: 'Социальное положение',
		fields: [{ "name": "ID", "key": "id" }, { "name": "ID МСЭД", "key": "msed_id" }, { "name": "Индекс", "key": "order" }, { "name": "Название", "key": "name" }]
	},

	{
		path: 'user_types',
		name: 'Льготный состав',
		fields: [{ "name": "ID", "key": "id" }, { "name": "ID МСЭД", "key": "msed_id" }, { "name": "Индекс", "key": "order" }, { "name": "Название", "key": "name" }]
	},

	{
		path: 'sources',
		name: 'Доставка',
		fields: [{ "name": "ID", "key": "id" }, { "name": "ID МСЭД", "key": "msed_id" }, { "name": "Индекс", "key": "order" }, { "name": "Название", "key": "name" }]
	},

	{
		path: 'doc_types',
		name: 'Вид документа',
		fields: [{ "name": "ID", "key": "id" }, { "name": "ID МСЭД", "key": "msed_id" }, { "name": "Индекс", "key": "order" }, { "name": "Название", "key": "name" }]
	},

	{
		path: 'officials',
		name: 'Должностные лица',
		fields: [{ "name": "ID", "key": "id" }, { "name": "ID МСЭД", "key": "msed_id" }, { "name": "Индекс", "key": "order" }, { "name": "Фамилия", "key": "last_name" }, { "name": "Имя", "key": "first_name" }, { "name": "Отчество", "key": "middle_name" }, { "name": "Позиция", "key": "position" }, { "name": "Организация", "key": "organization" }]
	},

	{
		path: 'organizations',
		name: 'Организации',
		fields: [{ "name": "ID", "key": "id" }, { "name": "ID МСЭД", "key": "msed_id" }, { "name": "Индекс", "key": "order" }, { "name": "Название", "key": "name" }]
	},]

export default directories